module.exports = __webpack_public_path__ + "img/IJYSHENG.f472f68f.svg";